import {
  EntityAction,
  EntityActionHandlerType,
  EntityActionType
} from '../../../entity-actions/interfaces/entity-actions';
import { ObjectConfigAction } from '../interfaces/object';

export const OBJECT_CONFIG_VIEW_CONFIG_ACTION_DISPLAY_DETAILS: EntityAction<ObjectConfigAction> = {
  action: ObjectConfigAction.VIEW_CONFIG,
  type: EntityActionType.INLINE_LINK,
  actionHandlerType: EntityActionHandlerType.CUSTOM,
  displayName: 'View Fields',
  inlineLinkOptions: {
    direction: 'left',
    icon: 'view-password',
    tag: 'button'
  }
};

export const OBJECT_CONFIG_EDIT_CONFIG_ACTION_DISPLAY_DETAILS: EntityAction<ObjectConfigAction> = {
  action: ObjectConfigAction.EDIT_CONFIG,
  type: EntityActionType.INLINE_ICON,
  actionHandlerType: EntityActionHandlerType.CUSTOM,
  displayName: 'Field Configuration',
  icon: 'edit',
  iconClass: 'text-primary',
  iconSize: 1
};

export const OBJECT_CONFIG_ACTIONS_DISPLAY_DETAILS: EntityAction<ObjectConfigAction>[] = [
  OBJECT_CONFIG_VIEW_CONFIG_ACTION_DISPLAY_DETAILS,
  OBJECT_CONFIG_EDIT_CONFIG_ACTION_DISPLAY_DETAILS,
  {
    action: ObjectConfigAction.TRUNCATE_AND_LOAD,
    type: EntityActionType.MENU,
    actionHandlerType: EntityActionHandlerType.CONFIRM,
    displayName: 'Resync Object',
    icon: 'syncing'
  }
];
